import uris from '../utils/uris'
import axios from '../utils/axiosWrapper'

import {find, filter, assign} from 'lodash'

let store = []
let isLoaded = false

export default {
  getStructures (options) {
    /*
    options: {
      userID: ''
      permissions: [],
      onSuccess: ()
      onError: ()
    }
    */
    axios.post(uris.URL_GET_STRUCTURES, {
      ...options.data
    })
      .then((response) => {
        // console.log('Se obtuvieron las estructuras')
        if (options.onSuccess) {
          options.onSuccess(response)
        }
      }, (err) => {
        console.warn('Error obteniendo las estructuras')
        if (options.onError) {
          options.onError(err)
        }
      })
  },
  getChildren (items, itemID) {
    return filter(items, (item) => item.containedBy === itemID)
  },
  isHeritableDataLoaded () {
    return isLoaded
  },
  getHeritableItems (options) {
    /*
    options: {
      userID: ''
      permissions: [],
      onSuccess: ()
      onError: ()
    }
    */
    if (!isLoaded || options.forceLoad) {
      axios.post(uris.URL_GET_HERITABLE_ITEMS, {
        ...options.data
      })
        .then((response) => {
          let temp = response.data.rows

          filter(temp, (item) => {
            let children = this.getChildren(temp, item.itemID)

            assign(item, {heritable: 1})
            return (
              item.isFolder === 1 &&
              // A los items que cumplan con lo previo
              //  asignales el parámetro de heredable
              //  además de conteo (directo) de items
              assign(item, {
                // heritable: 1,
                childrenCount: children.length,
                children
              })
            )
          })

          store.splice(0)
          store.push(...temp)
          isLoaded = true
          if (options.onSuccess) {
            options.onSuccess(store)
          }
        }, (err) => {
          console.warn('Error obteniendo las estructuras')
          if (options.onError) {
            options.onError(err)
          }
        })
    } else {
      if (options.onSuccess) {
        options.onSuccess(store)
      }
    }
  },
  findHeritableItemByID (itemID) {
    return find(store, (i) => i.itemID === itemID)
  },
  checkStructureName (options) {
    /*
    options: {
      userID: ''
      permissions: [],
      onSuccess: ()
      onError: ()
    }
    */
    axios.post(uris.URL_CHECK_STRUCTURE_NAME, {
      ...options.data
    })
      .then((response) => {
        // console.log('Checkeo correcto')
        if (options.onSuccess) {
          options.onSuccess(response)
        }
      }, (err) => {
        console.warn('La estructura no ha podido revisada')
        if (options.onError) {
          options.onError(err)
        }
      })
  },
  createStructure (options) {
    /*
    options: {
      userID: ''
      permissions: [],
      onSuccess: ()
      onError: ()
    }
    */
    axios.post(uris.URL_CREATE_STRUCTURE, {
      ...options.data
    })
      .then((response) => {
        // console.log('Se ha creado una estructura', response.data)
        if (options.onSuccess) {
          options.onSuccess(response)
        }
      }, (err) => {
        console.warn('La estructura no ha podido crearse', err)
        if (options.onError) {
          options.onError(err)
        }
      })
  },
  createHeritableItem (options) {
    /*
    options: {
      data: {
        structureID: 0,
        itemName: '',
        isFolder: 0,
        description: '',
        labels: '',
        containedBy: 7
      },
      onSuccess: () => {},
      onError: () => {}
    }
    */

    axios.post(uris.URL_CREATE_HERITABLE_ITEM, {
      structureID: options.data.structureID,
      itemName: options.data.itemName,
      description: options.data.description,
      labels: options.data.labels,
      imageUrl: options.data.imageUrl,
      isFolder: options.data.isFolder,
      containedBy: options.data.containedBy,
      structureItemInheritance: options.data.structureItemInheritance
    })
      .then((response) => {
        // console.log('Se ha creado un item de estructura', response.data)
        if (options.onSuccess) {
          options.onSuccess(response.data.items)
        }
      }, (err) => {
        console.warn('El item de estructura no ha podido crearse', err)
        if (options.onError) {
          options.onError(err)
        }
      })
  },
  updateHeritableItem (options) {
    /*
    options: {
      data: {
        containedBy: ''
        structureID: ''
        isFolder: 0
        itemID: ''
        itemName: ''
        description: '' // O no en caso de folders
        labels: '' // Igual que campo [description],
        imageUrl: '' // Igual
        removed: 0
      },
      onSuccess: () => {},
      onError: () => {}
    }
    */

    let _parentDataArr = /^(HI?)(\d+)$/.exec(options.data.containedBy)
    let _parentData = {
      itemID: _parentDataArr ? _parentDataArr[2] : '0',
      structureItemInheritance: _parentDataArr ? _parentDataArr[1].startsWith('HI') : false
    }

    // eslint-disable-next-line
    const _isParentRoot = (options.data.containedBy == 0)
    const _structureID = options.data.structureID
    const _isFolder = options.data.isFolder
    const _itemID = /^(HI?)(\d+)$/.exec(options.data.itemID)[2]
    const _parentItemID = _parentData.itemID
    const _parentStructureItemInheritance = _parentData.structureItemInheritance
    const _newItemName = options.data.itemName
    const _newDescription = options.data.description
    const _newLabels = options.data.labels
    const _newImageUrl = options.data.imageUrl
    const _removed = options.data.removed

    axios.post(uris.URL_UPDATE_HERITABLE_ITEM, {
      isParentRoot: _isParentRoot,
      structureID: _structureID,
      isFolder: _isFolder,
      itemID: _itemID,
      parentItemID: _parentItemID,
      parentStructureItemInheritance: _parentStructureItemInheritance,
      newItemName: _newItemName,
      newDescription: _newDescription,
      newLabels: _newLabels,
      newImageUrl: _newImageUrl,
      removed: _removed
    })
      .then((response) => {
        if (options.onSuccess) {
          options.onSuccess(response)
        }
      }, (error) => {
        if (options.onError) {
          options.onError(error)
        }
      })
  },
  createHeritableStructure (options) {
    /*
    options: {
      data: {
        folderName: ''
      },
      onSuccess: () => {},
      onError: () => {}
    }
    */
    axios.post(uris.URL_CREATE_HERITABLE_STRUCTURE, {
      structureName: options.data.folderName
    })
      .then((response) => {
        if (options.onSuccess) {
          options.onSuccess(response)
        }
      }, (error) => {
        console.warn('La estructura no ha podido crearse', error)
        if (options.onError) {
          options.onError(error)
        }
      })
  },
  replicateStructure (options) {
    /*
    options: {
      data: {
        structureID: 0,
        folderName: '',
        containedBy: 0
      },
      onSuccess: () => {}.
      onError: () => {}
    }
    */
    axios.post(uris.URL_REPLICATE_STRUCTURE, {
      structureID: options.data.structureID,
      folderName: options.data.folderName,
      containedBy: options.data.containedBy
    })
      .then((response) => {
        if (options.onSuccess) {
          options.onSuccess(response)
        }
      }, (error) => {
        console.warn('La estructura no pudo duplicarse', error)
        if (options.onError) {
          options.onError(error)
        }
      })
  },
  removeStructure (options) {
    /*
    options: {
      data: {
        structureID: 0,
        structureItemInheritance: false
      },
      onSuccess: () => {},
      onError: () => {}
    }
    */
    axios.post(uris.URL_REMOVE_STRUCTURE, {
      structureID: options.data.structureID,
      structureItemInheritance: options.data.structureItemInheritance
    })
      .then((response) => {
        if (options.onSuccess) {
          options.onSuccess(response)
        }
      }, (error) => {
        console.warn('La estructura no pudo borrarse', error)
        if (options.onError) {
          options.onError(error)
        }
      })
  },
  updateSpecificItemData (options) {
    /*
    options: {
      data: {
        items: []
      },
      onSuccess: () => {},
      onError: () => {}
    }
    */
    axios.post(uris.URL_UPDATE_SPECIFIC_ITEM_DATA, {
      items: options.data.items
    })
      .then((response) => {
        if (options.onSuccess) {
          options.onSuccess(response)
        }
      }, (error) => {
        console.warn('Los items no pudieron actualizarse', error)
        if (options.onError) {
          options.onError(error)
        }
      })
  },
  replicateFolder (options) {
    /*
    options: {
      data: {
        itemID: [],
        originalName: '',
        folderName: ''
      },
      onSuccess: () => {},
      onError: () => {}
    }
    */
    axios.post(uris.URL_REPLICATE_FOLDER, {
      itemID: options.data.itemID,
      originalName: options.data.originalName,
      folderName: options.data.folderName
    })
      .then((response) => {
        if (options.onSuccess) {
          options.onSuccess(response)
        }
      }, (error) => {
        console.warn('El folder no pudo replicarse', error)
        if (options.onError) {
          options.onError(error)
        }
      })
  },
  buildStructure (options) {
    /*
    options: {
      data: '',
      onSuccess: (),
      onError: ()
    }
    */
    axios.post(uris.URL_BUILD_STRUCTURE, {
      ...options.data
    })
      .then((response) => {
        // console.log('Se ha construido la estructura', response.data)
        if (options.onSuccess) {
          options.onSuccess(response)
        }
      }, (err) => {
        console.warn('La estructura no ha podido construirse', err)
        if (options.onError) {
          options.onError(err)
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/storage/structureStorage.js